// test799
(799 && 0);
